import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import { convertirTextAMomentUTC, MASCARA_YYYYMMDD, MASCARA_DDMMYYYY } from '../../commons/gestioDates';
import { columnesTaulaIncidencies } from './configuracioTaulaIncidencies';

const mascaraMostrarDates = MASCARA_DDMMYYYY;

//TODO S'hauría de refactoritzar en un fitxer de comons. Perque afecta a diferents parts de l'aplicació
const renderitzarData = dataText => {
    if (dataText) {
        return convertirTextAMomentUTC(dataText, MASCARA_YYYYMMDD).format(mascaraMostrarDates);
    }
};

/**
 * Hi han columnes que s'han de renderitzar de manera concreta per aquest component. Aquestes
 * funcions de renderitzat esta definides en aquest objecte
 */
const renders = {
    'dataInici': renderitzarData,
    'dataFi': renderitzarData
};

const crearColumnesPerTaula = (columnes) => {
    columnes.forEach((columna) => {
        const nomColumna = columna.key;

        if (typeof renders[nomColumna] !== 'undefined') {
            columna.render = renders[nomColumna];
        }
    });

    return columnes;
};

const EstacioDetallIncidencies = (props) => {
    const { incidencies } = props;

    const columnes = crearColumnesPerTaula(columnesTaulaIncidencies());

    return (
        <Table
            rowKey={record => record.id}
            dataSource={incidencies}
            columns={columnes}
            size='small'
            bordered
            pagination={{pageSize: 4, hideOnSinglePage: true}}
        />
    );
};

EstacioDetallIncidencies.propTypes = {
    incidencies: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            idEstacio: PropTypes.number,
            idTipusIncidencia: PropTypes.number,
            dataInici: PropTypes.string,
            dataFi: PropTypes.string,
            descripcio: PropTypes.string,
            tipus: PropTypes.string
        })
    )
};

export default EstacioDetallIncidencies;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallIncidencies.js